module.exports = __webpack_public_path__ + "img/arrow-ss-templates.c86f78e6.png";